import * as React from "react";
import { Button } from "@chakra-ui/react";
import { casesActions } from "configs";
import { useToast, useDispatch } from "duck";

interface DiscardProps {
  id: number;
  onSuccess(): void;
}

const Discard: React.FC<DiscardProps> = ({ id, onSuccess }) => {
  const dispatch = useDispatch();
  const toast = useToast();

  return (
    <Button
      colorScheme="red"
      minW="150px"
      onClick={() => {
        dispatch(casesActions.removeCase(id));

        onSuccess();
        toast({
          status: "success",
          description: "Changes are discarded successfully."
        });
      }}
    >
      Discard Changes
    </Button>
  );
};

export default Discard;
